import React, { useState } from 'react';
import { Card } from './Card';
import { Button } from './Button';
import { XIcon, SearchIcon, UserPlusIcon } from 'lucide-react';
export default function AddEmployeeModal({
  onClose,
  onAddEmployee
}) {
  const [searchTerm, setSearchTerm] = useState('');
  // Mock API call for employee search
  const searchEmployees = term => {
    // This would be replaced with an actual API call
    return [{
      id: 101,
      name: 'Jennifer Thompson',
      avatar: 'https://randomuser.me/api/portraits/women/67.jpg'
    }, {
      id: 102,
      name: 'Robert Chen',
      avatar: 'https://randomuser.me/api/portraits/men/52.jpg'
    }, {
      id: 103,
      name: 'Priya Sharma',
      avatar: 'https://randomuser.me/api/portraits/women/31.jpg'
    }].filter(employee => employee.name.toLowerCase().includes(term.toLowerCase()));
  };
  const searchResults = searchTerm ? searchEmployees(searchTerm) : [];
  const handleAddEmployee = employee => {
    onAddEmployee(employee);
    onClose();
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-10">
      <Card className="w-full max-w-md" data-id="element-11">
        <div className="flex justify-between items-center mb-4" data-id="element-12">
          <h2 className="text-lg font-bold" data-id="element-13">Add Colleague</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full transition-colors" data-id="element-14">
            <XIcon size={20} className="text-gray-500" data-id="element-15" />
          </button>
        </div>
        <div className="relative mb-4" data-id="element-16">
          <SearchIcon size={18} className="absolute left-3 top-2.5 text-gray-400" data-id="element-17" />
          <input type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search by name" className="pl-10 w-full p-2 border rounded-lg" autoFocus data-id="element-18" />
        </div>
        <div className="max-h-60 overflow-y-auto" data-id="element-19">
          {searchResults.length > 0 ? searchResults.map(employee => <div key={employee.id} className="flex items-center p-3 rounded-lg mb-2 border border-gray-200 hover:bg-gray-50 cursor-pointer" onClick={() => handleAddEmployee(employee)} data-id="element-20">
                <img src={employee.avatar} alt={employee.name} className="w-10 h-10 rounded-full mr-3" data-id="element-21" />
                <span className="flex-1" data-id="element-22">{employee.name}</span>
                <UserPlusIcon size={18} className="text-blue-600" data-id="element-23" />
              </div>) : <div className="text-center py-4 text-gray-500" data-id="element-24">
              {searchTerm ? 'No matching colleagues found' : 'Type to search for colleagues'}
            </div>}
        </div>
        <div className="flex justify-end mt-4" data-id="element-25">
          <Button variant="outline" onClick={onClose} data-id="element-26">
            Cancel
          </Button>
        </div>
      </Card>
    </div>;
}